import { Reducer } from 'redux'
import { PricingActionTypes } from '../actions'
import { initialPricingStoreState, PricingStoreModel } from '../store.model'

export const pricingReducer: Reducer<PricingStoreModel> = (
  state = initialPricingStoreState,
  action
) => {
  switch (action.type) {
    case PricingActionTypes.STORE_ACTIVE_PRICE:
      return { ...state, price: action.payload }
    case PricingActionTypes.STORE_ACTIVE_VERSIONS:
      return { ...state, versions: action.payload }
    case PricingActionTypes.STORE_OPERANDS:
      return { ...state, operands: action.payload }
    case PricingActionTypes.STORE_COMPATIBLES_CALCULATION_PRICE_TYPE:
      return { ...state, calculationTypes: action.payload }
    case PricingActionTypes.STORE_COEFFICIENTS:
      return { ...state, coefficients: action.payload }
    default:
      return state
  }
}
